/**
 * WebDAV 同步模块
 *
 * 为 Zotero / Joplin / rclone 等第三方软件提供文件同步空间：
 * 用量统计、连接信息与文件管理。
 */

import type { WorkbenchModule } from '../types'

export const webdavModule: WorkbenchModule = {
  meta: {
    name: 'webdav',
    title: 'WebDAV 同步',
    description: '第三方软件文件同步空间（Zotero / Joplin / rclone）',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/webdav',
      name: 'webdav',
      component: () => import('./views/WebDavView.vue'),
      meta: { title: 'WebDAV 同步' }
    }
  ],
  menuItem: {
    id: 'webdav',
    label: 'WebDAV 同步',
    path: '/webdav',
    icon: 'hard-drive',
    order: 32
  }
}
